import { Component, Inject } from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';

@Component({
  selector: 'app-mat-snack-bar',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './mat-snack-bar.component.html',
  styleUrl: './mat-snack-bar.component.scss'
})
export class MatSnackBarComponent {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string) { }

}
